module.exports = __webpack_public_path__ + "static/media/psyApp.601e0cd1.png";